import { IPerformanceProduto } from "@core/models/varejo/performance-produto";
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IPerformanceProdutoState {
    data: IPerformanceProduto;
    loading: boolean;
    error: string | null;
}

const initialState: IPerformanceProdutoState = {
    data: {} as IPerformanceProduto,
    loading: false,
    error: null
};

export const performanceProdutoSlice = createSlice({
    name: 'performanceProdut',
    initialState,
    reducers: {
        performance_produto_fetching: (state) => {
            state.loading = true;
            state.data = {} as IPerformanceProduto;
            state.error = null;
        },
        performance_produto_success: (state, action: PayloadAction<IPerformanceProduto>) => {
            state.error = null;
            state.loading = false;
            state.data = action.payload;
        },
        performance_produto_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IPerformanceProduto;
        }
    }
});

export const { performance_produto_fetching, performance_produto_success, performance_produto_error } = performanceProdutoSlice.actions;

export const selectorPerformanceProduto = (state: AppState) => state.performanceProduto;

export default performanceProdutoSlice.reducer;